import axios from './../axios';

import { artistTypes, authTypes } from '@/types';

const googleLogin = (code: string) => axios.post('/artist/google-login', { code });

const loginUser = (payload: { email: string; password: string }) =>
  axios.post('/artist/login', payload);

const registerUser = (payload: { email: string; password: string; rePassword: string }) =>
  axios.post('/artist/register', payload);

const resetPassword = (payload: { emailToken: string; password: string; rePassword: string }) =>
  axios.post('/artist/change-password', payload);
const forgotPassword = (payload: { email: string }) =>
  axios.post('/artist/forgot-password', payload);

const resendVerificationEmail = (payload: { email: string }) =>
  axios.post('/artist/send-verification-email', payload);

const verifyEmail = (payload: { token: string }) => axios.post('/artist/verify-email', payload);

const sendOtP = (payload: { phone_no: string; phone_no_code: string }) =>
  axios.post('/artist/send-otp', payload);

const verifyOtp = (payload: { token: string; otp: string }) =>
  axios.post('/artist/verify-otp', payload);

const updateArtist = (payload: Partial<artistTypes.Artist>, id: string) =>
  axios.post(`/artist/${id}`, payload);

const fetchArtist = (id: string) => axios.get(`/artist/${id}`);

const refreshToken = (payload: { refresh_token: string }) =>
  axios.post('/artist/refresh-token', payload);

const avatarUpload = (payload: FormData, id: string) =>
  axios.post(`/artist/${id}/upload-avatar`, payload);

const getAvatarUploadUrl = (id: string, payload: { filename: string; mimetype: string }) =>
  axios.post(`/artist/${id}/get-avatar-upload-url`, payload);

const saveAvatarKey = (id: string, payload: { avatar_key: string }) =>
  axios.post(`/artist/${id}/upload-avatar`, payload);

const avatarDelete = (id: string) => axios.delete(`/artist/${id}/delete-avatar`);

const logoutArtist = () => axios.post('/artist/logout');

const contactUs = (payload: authTypes.ContactInfo) => axios.post('/artist/contact-us', payload);

const fetchWithdrawal = (id: string) => axios.get(`/withdraw/${id}`);
const fetchWithdrawAmount = () => axios.get('/withdraw/amount');
const createWithdrawal = (payload: { amount: string }) =>
  axios.post('/withdraw/create-new', payload);

const fetchSongLog = (id: string) => axios.get(`songs/${id}/reactions`);

const fetchDashboard = (payload: { artist_id: string; filter: string }) =>
  axios.post('/artist/dashboard', payload);

export {
  loginUser,
  registerUser,
  resendVerificationEmail,
  verifyEmail,
  sendOtP,
  verifyOtp,
  updateArtist,
  fetchArtist,
  resetPassword,
  forgotPassword,
  refreshToken,
  avatarUpload,
  getAvatarUploadUrl,
  saveAvatarKey,
  logoutArtist,
  googleLogin,
  fetchWithdrawal,
  fetchWithdrawAmount,
  contactUs,
  fetchSongLog,
  fetchDashboard,
  createWithdrawal,
  avatarDelete,
};
